import { format } from 'date-fns';

export const Capitalize = (str: string) => {
    if (!str) {
        return '';
    }
    const words = str?.split(' ') || [];

    for (let i = 0; i < words.length; i++) {
        words[i] = words[i][0].toUpperCase() + words[i].substr(1);
    }
    return words.join(' ');
};
export const Serialize: any = (obj: any, prefix: string) => {
    const str = [];
    let p;
    for (p in obj) {
        if (obj.hasOwnProperty(p)) {
            var k = prefix ? prefix + '[' + p + ']' : p,
                v = obj[p];
            str.push(
                v !== null && typeof v === 'object'
                    ? Serialize(v, k)
                    : encodeURIComponent(k) + '=' + encodeURIComponent(v),
            );
        }
    }
    return str.join('&');
};
export function getWeekday(dateString: string) {
    const days = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
    const date = new Date(dateString);
    return days[date.getDay()];
}

export const displayDuration = (seconds: number) => {
    seconds = seconds || 0;
    let result: string[] = [];
    result.unshift(String(seconds % 60).padStart(2, '0'));
    seconds = parseInt(seconds / 60 + '');
    result.unshift(String(seconds % 60).padStart(2, '0'));
    seconds = parseInt(seconds / 60 + '');
    result.unshift(String(seconds % 24).padStart(2, '0'));
    seconds = parseInt(seconds / 24 + '');
    return result.join(':');
};
export const displayDateAndMonth = (date: string) => {
    return format(new Date(date), 'dd-MMM');
};

export function extractYoutubeVideoId(url: string) {
    const regex = /(?:v=)([^&]+)/;
    const result = url.match(regex);

    return result ? result[1] : null;
}

export function displayPrice(price: number) {
    return price.toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
}

export function getFullName(firstName: string, lastName?: string) {
    return `${firstName} ${lastName}`;
}

export function toCamelCase(str: string): string {
    return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
}

export function toSnakeCase(str: string): string {
    return str.replace(/([A-Z])/g, '_$1').toLowerCase();
}

export function convertKeysToCamelCase(obj: any): any {
    if (obj === null || obj === undefined) return obj;
    if (typeof obj !== 'object') return obj;
    if (Array.isArray(obj)) return obj.map(convertKeysToCamelCase);

    const newObj: any = {};
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const camelKey = toCamelCase(key);
            newObj[camelKey] = convertKeysToCamelCase(obj[key]);
        }
    }
    return newObj;
}

export function convertKeysToSnakeCase(obj: any): any {
    if (obj === null || obj === undefined) return obj;
    if (typeof obj !== 'object') return obj;
    if (Array.isArray(obj)) return obj.map(convertKeysToSnakeCase);

    const newObj: any = {};
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const snakeKey = toSnakeCase(key);
            newObj[snakeKey] = convertKeysToSnakeCase(obj[key]);
        }
    }
    return newObj;
}

export const validateEndDateAfterStart = (startField: string, errorMessage: string) => {
    return (value: any, allValues: any) => {
        if (!value || !allValues[startField]) return undefined;
        const startDate = new Date(allValues[startField]);
        const endDate = new Date(value);
        if (endDate < startDate) {
            return errorMessage;
        }
        return undefined;
    };
};

export function getFirstAndLastDay(date: Date) {
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    lastDay.setHours(23, 59, 59, 999);
    return { firstDay, lastDay };
}
